import React from 'react'
import request from 'superagent'
import ScrollUpButton from 'react-scroll-up-button'

class DetailPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {rooms: [], isLoaded: false}
  }
  componentWillMount () {
    request
      .get('https://sharehouse-116bb.appspot.com/api/rooms')
      .end((err, res) => {
        if (err) {
          console.error(err)
        } else {
          console.log('Succeed to receive data.')
          this.setState({rooms: res.body.rooms, isLoaded: true})
        }
      })
  }
  priceListMsg (isFirstFloor) {
    if (!this.state.isLoaded) return (<p className='rooms-loading'>読み込み中...</p>)
    const filteredRooms = isFirstFloor ? this.state.rooms.filter(doc => doc.num === 101) : this.state.rooms.filter(doc => doc.num !== 101)
    const rooms = filteredRooms.map(doc => {
      let availabilityClassName = 'room-availability'
      if (doc.availability === '入居中') {
        availabilityClassName += ' room-not-available'
      } else {
        availabilityClassName += ' room-available'
      }
      return (
        <tr key={doc.num}>
          <td className='room-num'>{doc.num}</td>
          <td className='room-fee'>{doc.fee}</td>
          <td className={availabilityClassName}>{doc.availability}</td>
          <td className='room-note'>{doc.note}</td>
        </tr>
      )
    })
    return (
      <table>
        <thead>
          <tr>
            <th scope='col'>部屋番号</th>
            <th scope='col'>賃料</th>
            <th scope='col'>利用状況</th>
            <th scope='col'>備考</th>
          </tr>
        </thead>
        <tbody>
          {rooms}
        </tbody>
      </table>
    )
  }
  render () {
    const priceList1stFloor = this.priceListMsg(true)
    const priceList2ndFloor = this.priceListMsg(false)
    return (
    <div className='detail'>
      <h2>間取り・家賃</h2>
      <ul className="breadcrumb">
        <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
          <a href="/" itemProp="url">
            <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
          </a>
        </li>
        <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
          <span itemProp="title"> <i className="fas fa-caret-right"></i> 間取り・家賃</span>
        </li>
      </ul>
      <div className='main'>
        <p>駄菓子屋付きの女性限定のシェアハウスです。敷金・礼金・更新料・保証人不要、家具・家電付き、全室エアコン・無線インターネット完備、全個室施錠付きの賃貸住宅です。中庭で家庭内菜園や優雅なティータイムを楽しみ、屋上テラスも利用できます。駄菓子屋での接客でお小遣い稼ぎも可能です。</p>
      </div>
      <div className='main-list'>
        <table>
          <thead>
            <tr>
              <th scope='col'>項目</th>
              <th scope='col'>内容</th>
              <th scope='col'>備考</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='name'>賃料</td>
              <td className='content'>39,000〜45,000円(税込)</td>
              <td className='note'>鍵付き個室＋共有施設（リビング、キッチン、浴室、シャワー、屋上テラス等）＋占有バルコニー＋占有菜園</td>
            </tr>
            <tr>
              <td className='name'>管理費（共益費）</td>
              <td className='content'>12,000円(税込)/人月</td>
              <td className='note'>水道光熱費、無線インターネット利用料、駄菓子屋損失（廃棄、雑損、窃盗、破損等）、修繕積立金が含まれます</td>
            </tr>
            <tr>
              <td className='name'>敷金/礼金</td>
              <td className='content'>0ヶ月/0ヶ月</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>更新料</td>
              <td className='content'>無し</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>火災保険料</td>
              <td className='content'>オーナー加入済み</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>鍵交換費</td>
              <td className='content'>無料</td>
              <td className='note'>オーナーの負担</td>
            </tr>
            <tr>
              <td className='name'>保証金</td>
              <td className='content'>無し</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>クリーニング費</td>
              <td className='content'>原則無料</td>
              <td className='note'>賃料・管理コストを抑えるため、入居者自身で居住スペースの清掃を行って頂きます</td>
            </tr>
            <tr>
              <td className='name'>契約期間</td>
              <td className='content'>3ヶ月</td>
              <td className='note'>入居者様の安全快適な生活を守るために、3ヶ月更新の定期建物賃貸借契約となっております</td>
            </tr>
            <tr>
              <td className='name'>構造規模</td>
              <td className='content'>木造2階建 全6室、屋上テラス付き</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>築年月</td>
              <td className='content'>令和2年7月</td>
              <td className='note'></td>
            </tr>
            <tr>
              <td className='name'>最終更新</td>
              <td className='content'>令和4年2月</td>
              <td className='note'></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='feature'>
        <h3>特徴</h3>
        <div className='feature-box'>
          <h4><i className="fas fa-user-shield"></i>占有部分</h4>
          <p className='feature-content'>施錠付き個室、1畳分の収納スペース、エアコン、ベッド、ドレッサー兼作業机、椅子、照明器具、カーテン、ぬれ縁（1階のお部屋）、占有バルコニー（2階のお部屋）、自転車</p>
          <h4><i className="fas fa-user-friends"></i>共用部分</h4>
          <p className='feature-content'>トイレ２室（温水洗浄便座）、浴室1室、シャワー1室、洗面台2台、18畳リビングダイニング、カウンターキッチン、駄菓子屋、中庭、屋上テラス(33畳)、自転車置き場<br /><br />エアコン、冷蔵庫、電子レンジ、オーブントースター、IHコンロ、湯沸かし器、食洗機、炊飯器、洗濯機、掃除機、43型録画機能付きテレビ、ワイヤレススキャナー機能付きプリンター、iPad、AM・FMラジオ、キッチンボード、本棚、ソファ、IH対応鍋、IH対応フライパン、生活用品（トイレットペーパー）、無線LAN（光回線）、iPad、ファミコン、テニスラケット4つ、卓球ラケット4つ</p>
        </div>
      </div>
      <div className='price-list'>
        <h3>賃料表</h3>
        <img src='images/floor_1st.png' alt='floor_1st' />
        {priceList1stFloor}
        <img src='images/floor_2nd.png' alt='floor_2nd' />
        {priceList2ndFloor}
        <img src='images/floor_terras.png' alt='floor_terras' />
      </div>
      <div className='condition'>
        <h3>入居条件</h3>
        <ul>
          <li>女性限定</li>
          <li>18歳以上（未成年者は親権者様の同意書が必要）</li>
          <li>外国籍可</li>
          <li>保証人不要</li>
        </ul>
      </div>
      <ScrollUpButton style={{width: 30, height: 30}} />
    </div>
    )
  }
}

export default DetailPage


// WEBPACK FOOTER //
// ./src/DetailPage.js